
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
export default {
  components: { InnerPageTitle },
  data() {
    return {
      alertBox: {
        status: false,
        variant: '',
        message: '',
      },
      loading: false,
      form: {
        password: '',
        confirmPassword: '',
      },
    }
  },
  methods: {
    async SEND_RESET_PASSWORD(e) {
      e.preventDefault()
      if (this.form.password !== this.form.confirmPassword) return
      this.alertBox.status = false
      this.loading = true
      const response = await this.$api.post('Users/ResetPassword', {
        token: this.$route.query.token,
        newPassword: this.form.password,
      })
      if (response.message === 'OK') {
        this.alertBox = {
          status: true,
          variant: 'success',
          message: this.$custom$t('valid.successChangedPassword'),
        }
        setTimeout(() => {
          this.$router.push(this.localePath('/giris-yap'))
        }, 2500)
      } else if (response.message === 'NOTFOUND') {
        this.alertBox = {
          status: true,
          variant: 'danger',
          message: this.$custom$t('valid.mailNotFound'),
        }
      } else
        this.alertBox = {
          status: true,
          variant: 'danger',
          message: this.$custom$t('valid.errorChangedPassword'),
        }
      this.loading = false
    },
  },
  mounted() {
    if (this.$route.query.token === undefined)
      return this.$router.push(this.localePath('/forget-password'))
    if (!this.$route.query.token.startsWith('ey'))
      return this.$router.push(this.localePath('/forget-password'))
  },
}
